// メニューを開く関数
const slideDown = (el) => {
  el.style.height = 'auto'
  let h = el.offsetHeight
  el.style.height = h + 'px'
  el.animate([{ height: 0 }, { height: h + 'px' }], {
    duration: 300,
  })
}

// メニューを閉じる関数
const slideUp = (el) => {
  el.style.height = 0
}

let activeIndex = null

const accordions = document.querySelectorAll('ul.include-accordion')

accordions.forEach((accordion) => {
  const accordionBtns = accordion.querySelectorAll('.accordionBtn')

  accordionBtns.forEach((accordionBtn) => {
    accordionBtn.addEventListener('click', (e) => {
      const currentItem = accordionBtn.parentNode
      const currentContent = accordionBtn.nextElementSibling
      const isActive = currentItem.classList.contains('active')

      accordionBtns.forEach((btn) => {
        btn.parentNode.classList.remove('active')
        slideUp(btn.nextElementSibling)
      })

      if (!isActive) {
        currentItem.classList.add('active')
        slideDown(currentContent)
      }

      const container = accordion.closest('.scroll-control')
      if (container) {
        if (currentItem.classList.contains('active')) {
          container.classList.add('active')
        } else {
          container.classList.remove('active')
        }
      }
    })
  })
})

// スマホナビ
const initializeDetailsAccordion = (details) => {
  const summary = details.querySelector('summary')
  const panel = details.querySelector('summary + *')

  if (!(details && summary && panel)) return

  let isTransitioning = false

  const onOpen = () => {
    if (details.open || isTransitioning) return
    isTransitioning = true
    panel.style.gridTemplateRows = '0fr'
    details.setAttribute('open', '')
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        panel.style.gridTemplateRows = '1fr'
      })
    })
    panel.addEventListener(
      'transitionend',
      () => {
        isTransitioning = false
      },
      { once: true },
    )
  }

  const onClose = () => {
    if (!details.open || isTransitioning) return
    isTransitioning = true
    panel.style.gridTemplateRows = '0fr'
    panel.addEventListener(
      'transitionend',
      () => {
        details.removeAttribute('open')
        panel.style.gridTemplateRows = ''
        isTransitioning = false
      },
      { once: true },
    )
  }

  summary.addEventListener('click', (event) => {
    event.preventDefault()
    if (details.open) {
      onClose()
    } else {
      onOpen()
    }
  })
}

const detailsAccordions = document.querySelectorAll('.js_accordion')
detailsAccordions.forEach((acc) => {
  initializeDetailsAccordion(acc)
})

document.addEventListener('DOMContentLoaded', () => {
  // アコーディオンのトグルボタン（タイトル部分）を取得
  const categoryBtns = document.querySelectorAll('.js-accordion-btn')

  categoryBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      // ウィンドウ幅が990px以上(PC表示)の場合はアコーディオン動作を無効化
      if (window.innerWidth >= 990) return

      const wrap = btn.closest('.js-accordion-wrap')

      // クラスの付け外しでCSSの grid-template-rows を動かして開閉
      wrap.classList.toggle('is-open')
    })
  })
})
